/**
 * @description
 * @author librajt
 * @date
 */

import React from 'react';
import IUserMedalInfo from '../../../../interface/userMedal';
import { getMedalIcon, MEDAL_SIZE } from '../../../utils/userAchievementUtil';
import './userMedalIcon.scss';
import ImageUtil from '../../../utils/imageUtil';
import { useContext } from 'react';
import { AppContext } from '../../../../context/appContext';

interface IUserMedalIconProps {
    userMedalInfo: IUserMedalInfo;
    userMedalWidth: 20 | 30 | 16 | 12;
}

export default function UserMedalIcon(props: IUserMedalIconProps) {
    const { state } = useContext(AppContext);
    const { cdnHost } = state;

    let size;
    const { userMedalWidth, userMedalInfo } = props;
    if (userMedalWidth) {
        size = {
            width: userMedalWidth + 'px',
            height: userMedalWidth + 'px',
        };
    }

    let medalIcon = getMedalIcon(userMedalInfo.medal_type, userMedalInfo.medal_rank, MEDAL_SIZE.SMALL, cdnHost);
    medalIcon = ImageUtil.process(medalIcon || '', {});
    return (
        <div className="user-medal-icon">
            <div className="user-medal" style={size}>
                <div className="img">
                    <img src={medalIcon} alt="" />
                </div>
            </div>
        </div>
    );
}
